module.exports = __webpack_public_path__ + "static/media/new-york-42.02330b50.jpg";